/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module basic-styles/SAVE/SAVEediting
 */

import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import Command from '@ckeditor/ckeditor5-core/src/command';


const SAVE = 'save';

/**
 * The SAVE editing feature.
 *
 * It registers the `'SAVE'` command and introduces the `SAVE` attribute in the model which renders to the view
 * as a `<strong>` element.
 *
 * @extends module:core/plugin~Plugin
 */

class SaveCommand extends Command {
    execute(message){
        this.editor.fire('save',arguments);
    }
}

export default class SaveEditing extends Plugin {
	/**
	 * @inheritDoc
	 */
	init() {
		const editor = this.editor;
		
		// Create SAVE command.
		editor.commands.add( SAVE, new SaveCommand( editor, SAVE ) );

		// Set the Ctrl+B keystroke.
		editor.keystrokes.set( 'CTRL+S', SAVE );
	}
}
